import { useCatalog } from '../../contexts/CatalogContext';
import { rating } from '../../core/format/currency';
import { HomeHero } from './HomeHero';
import { HomeManifest } from './HomeManifest';
import { ConcernFinder } from './ConcernFinder';
import { HomeShelf } from './HomeShelf';
import { HomeStory } from './HomeStory';
import { HomeReviews } from './HomeReviews';
import { HomeProtocols } from './HomeProtocols';
import { HomeJournal } from './HomeJournal';
import { HomeVisit } from './HomeVisit';
import { HOME_SHELF, homeBestsellers } from './homeRules';

/**
 * De homepage (docs/VORMGEVING.md §3). Eén verhaal: salon én thuis, door één specialist.
 * Ritme van tonen, elk blok één taak:
 *
 * 1. opening met de twee deuren (sand): wie, wat, waar naartoe
 * 2. waar ik voor sta (blush): waarom salon en producten bij elkaar horen
 * 3. klachtenkiezer (shell): per klacht thuis én salon naast elkaar
 * 4. salonfavorieten (sand): de plank
 * 5. werkwijze als ritueel (salie)
 * 6. reviews (sand)
 * 7. protocollen (shell)
 * 8. journal (sand)
 * 9. kom langs (blush), daarna de footer (klei)
 */
export function Home() {
  const {
    products,
    shopRating
  } = useCatalog();
  const shelf = homeBestsellers(products, HOME_SHELF);
  return <>
      <HomeHero reviewCount={shopRating.count} avgRating={rating(shopRating.average)} data-id="element-7341" data-mp="kz13iyzy165c" />
      <HomeManifest data-id="element-7342" data-mp="g0znyo1q7oym" />
      <ConcernFinder data-id="element-7343" data-mp="g1rirwni1inu" />
      {shelf.length > 0 && <HomeShelf products={shelf} total={products.length} data-id="element-7344" data-mp="3oh1hqvw3e7re" />}
      <HomeStory data-id="element-7345" data-mp="3ohkve0epm9zm" />
      <HomeReviews data-id="element-7346" data-mp="3oj5k39eceypk" />
      <HomeProtocols data-id="element-7347" data-mp="3ji80csdopwly" />
      <HomeJournal data-id="element-7348" data-mp="3jirl0gupyz3o" />
      <HomeVisit data-id="element-7349" data-mp="3jj9mbrw8o3ig" />
    </>;
}